"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _createStyles = require("../styles/createStyles");
var _utilities = require("../utilities");
const _excluded = ["classes", "className", "component", "square", "elevation", "variant"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// convert Elevations to strings

const useStyles = exports.useStyles = (0, _createStyles.createStyles)(_ref => {
  let {
    theme
  } = _ref;
  const elevations = theme.shadows.reduce((acc, shadow, index) => {
    acc[`elevation${index.toString()}`] = {
      boxShadow: shadow
    };
    return acc;
  }, {});
  return _objectSpread({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      transition: theme.transitions.create('box-shadow')
    },
    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    },
    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      border: `1px solid ${theme.palette.divider}`
    }
  }, elevations);
});
/**
 * **❗️ DEPRECATED**
 *
 * In Material Design, the physical properties of paper are translated to the screen.
 * The background of an application resembles the flat, opaque texture of a sheet of paper,
 * and an application’s behavior mimics paper’s ability to be re-sized, shuffled, and bound together in multiple sheets.
 *
 * @deprecated
 */
const Paper = /*#__PURE__*/React.forwardRef(function Paper(props, forwardedRef) {
  const {
      classes: classesOverrides,
      className,
      component: Component = 'div',
      square = false,
      elevation = 1,
      variant = 'elevation'
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    classes,
    cx
  } = useStyles({
    classesOverrides
  });
  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
    className: cx(classes.root, {
      [classes.rounded]: !square,
      [classes[`elevation${(0, _utilities.capitalizeFirstWord)(String(elevation))}`]]: variant === 'elevation',
      [classes.outlined]: variant === 'outlined'
    }, className),
    ref: forwardedRef
  }, other));
});
var _default = exports.default = Paper;